import type { Market } from '../lib/market';

interface Props {
  market: Market;
  onChange: (m: Market) => void;
}

export function MarketTabs({ market, onChange }: Props) {
  return (
    <div className="inline-flex rounded-lg border border-(--border) bg-(--bg-soft) p-0.5 text-xs">
      <TabBtn active={market === 'TW'} onClick={() => onChange('TW')}>🇹🇼 台股</TabBtn>
      <TabBtn active={market === 'US'} onClick={() => onChange('US')}>🇺🇸 美股</TabBtn>
    </div>
  );
}

function TabBtn({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-1 rounded font-semibold transition-colors ${
        active
          ? 'bg-(--accent)/15 text-(--accent) border border-(--accent)/40'
          : 'text-(--text-muted) hover:text-(--text-primary)'
      }`}
    >
      {children}
    </button>
  );
}
